// Srpski (latinica) - sr - 塞尔维亚语（拉丁字母）
const sr = {
  home: {
    home: 'Početna',
    solutions: 'Rešenja',
    support: 'Podrška',
    news: 'Vesti',
    aboutUs: 'O nama',
    contactUs: 'Kontakt',
    cgm: 'CGM',
    download: 'Preuzimanja',
    helpCenter: 'Centar za pomoć',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Sva prava zadržana.',
    menu: 'Meni',
    quickLinks: 'Brze veze',
    contact: 'Kontakt',
    legal: 'Pravno',
    termsUse: 'Uslovi korišćenja',
    privacyPolicy: 'Politika privatnosti',
    portal: 'Korisnički portal',
    hClinic: 'H-Klinika',
    emailPlaceholder: 'E-pošta',
    subscribe: 'Pretplati se',
    signUp: 'Prijavite se za najnovije vesti',
    downloadApp: 'Preuzmi aplikaciju',
    blogNews: 'Blog i vesti',
    latestArticles: 'Najnoviji članci',
    viewAllArticles: 'Pogledaj sve članke',
    empower: 'Unapredite svoj put ka zdravlju sa nama',
    empowerList1Content:
      'Hippo CGM je znatno olakšao upravljanje dijabetesom mog sina. Možemo koristiti HIPPOLINK da jasno pratimo obrasce kretanja glukoze i sa sigurnošću prilagodimo njegovu terapiju. To nam pruža osećaj sigurnosti.',
    empowerList1Name: 'Petra N., Češka (majka deteta sa dijabetesom tip 1)',
    empowerList2Content:
      'Pacijentima ovde preporučujemo HIPPO CGM zbog stabilnih performansi i dužeg vremena nošenja. Povratne informacije korisnika su bile odlične, posebno od onih koji traže pristupačniju opciju.',
    empowerList2Name: 'Dr Luka B., endokrinolog, Italija',
    empowerList3Content:
      'Nedavno sam počeo da koristim Hippo CGM - prijatan je i precizan, a alarmi su mi pomogli da izbegnem hipoglikemije tokom noći. Veoma sam zadovoljan dosadašnjim rezultatima.',
    empowerList3Name:
      'Fahad A., Saudijska Arabija (pacijent sa dijabetesom tip 2)',
    reliable: 'Vaš pouzdan partner za upravljanje dijabetesom',
    hippoH1: 'HiPPO H1',
    challenges: 'Izazovi',
    constant: 'Stalno praćenje šećera u krvi',
    traditional:
      'Tradicionalno bockanje prsta radi merenja šećera u krvi može biti bolno i nepraktično.',
    dataOverload: 'Preopterećenje podacima',
    managing:
      'Upravljanje podacima o nivou šećeru iz različitih izvora može biti preopterećujuće i teško za tumačenje',
    treatment: 'Prilagođavanje terapije',
    accurately:
      'Tačno određivanje terapije na osnovu vrednosti šečera u krvi može biti složeno',
    lifestyle: 'Integracija u stil života',
    balancing:
      'Balansiranje ishrane, aktivnosti i terapije sa svakodnevnim aktivnostima može predstavljati izazov',
    hippoCan: 'Hippo biosenzori nude',
    painless: 'Bezbolno i diskretno praćenje',
    ourCgm:
      'Naš CGM obezbeđuje kontinuirano merenje nivoa šećera u krvi bez potrebe za bockanjem prsta',
    realTime: 'Podaci i uvidi u realnom vremenu',
    accessYour:
      'Jednostavan pristup podacima o šećeru u krvi putem pametnog telefona, što vam omogućava da pratite trendove i donosite odluke na osnovu podataka.',
    personalized: 'Personalizovana podrška',
    ourCgmSys:
      'Upozorenja i podsetnici u Hippo BioSensors APP vam mogu pomoći sa da se pridržavate svog plana lečenja.',
    improved: 'Bolje donošenje odluka',
    gain: 'Dublje razumevanje kako vaše telo reaguje na događaje, omogućavajuću vam da bolje kompenzujete fluktuacije glukoze. Povratne informacije u realnom vremenu  omogućavaju vam da efikasnije prilagođavate svoje svakodnevne aktivnosti.',
    // about: 'O nama',
    companyProfile: 'Profil kompanije',
    banner1Title: 'Dobrodošli u Hippo Medical',
    banner1Content: 'Na čelu CGM inovacije',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Postavljamo nove standarde u CMG tehnologiji',
    banner3Content: '24/7 zaštita glukoze',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'Lider u CGM tehnologiji',
    // 错误提示
    subscribeSuccess: 'Pretplata uspešna', // ai翻译
    subscribeFailed: 'Pretplata nije uspela', // ai翻译
    invalidEmail: 'Nevažeća email adresa', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return sr.home.banner1Title;
    },
    get banner1Content() {
      return sr.home.banner4Content;
    },
    whyChoose: 'Zašto izabrati HiPPO CGM',
    accurate: 'Preciznost kojoj možete verovati',
    accurateText: 'Enzimska tehnologija treće generacije donosi više',
    accurateText1: 'stabilne i precizne performanse',
    easyUse: 'Jednostavno za korišćenje',
    easyUseText: '14 dana kontinuiranog praćenja',
    realTime: 'Praćenje',
    realTimeText: 'Upozorenja za hipo i hiperglikemiju u realnom vremenu',
    realTimeText1:
      'Deljenje podataka sa člamovima porodice i zdravstvenim radnicima u realnom vremenu',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    keep: 'Informiše vas bilo kada i bilo gde',
    withHippo: 'Sa HiPPO aplikacijama i portalom',
    smallSensors: 'Mali senzori, prijatno nošenje',
    agpReport:
      'Profesionalni AGP izveštaj koji omogućava zdravstvenim radnicima i korisnicima da odmah registruju ključne informacije',
    unlimitedFollow:
      'Neograničeno praćenje, omogućava zdravstvenim radnicima da upravljaju većim brojem korisnika',
    iWatchApp: 'Dostupna iWatch aplikacija',
    certified: 'Sertifikovano za decu',
    loremIp:
      'Sistem je klinički validiran i zvanično sertifikovan za upotrebu kod dece   starije od 3 godine, obezbedjujući sigurnost, preciznost i udobnost za mlađe pacijente. Uz dokazanu taćnost senzora i nežne materijale prilagođene koži, omogućava pouzdano praćenje nivoa glukoze kod dece i adolescenata, pružajući zdravstvenim radnicima podršku u sigurnom i na podacima zasnovanom vođenju dijabetesa',
  },
  news: {
    date: 'Datum',
    recommendedArticles: 'Preporučeni članci',
  },
  support: {
    download: 'Preuzmi vodiče',
    supportDown: 'Podrška/Preuzimanja',
  },
  about: {
    welcome: 'Dobrodošli u Hippo Medical',
    covered: 'Pokrivene zemlje',
    patents: 'Patenti',
    features: 'Funkcije3',
    ring: 'Prsten',
    apparently:
      'Pametni prsten koji prati parametre kao što su nivo kiseonika u krvi, srčani ritam i san. Još važnije, poseduje algoritamsku povezanost sa našim CGM sistemom. Dolazi 2026. godine-pratite nas!',
    cgmSky:
      'Profesionalni CGM za pacijente i kliničku praksu lekara. Pruža visoku preciznost, jednostavnu interakciju sa softverom i pokreću ga Hippo Medical algoritmi. Dostupan od juna 2025.!',
    smartWatch: 'Pametni sat',
    byTheSame:
      'Nosivi uređaj za merenje krvnog pritiska koji omogućava kontinuirano praćenje sistolnog, dijastolnog, i srednjeg arterijskog pritiska i drugih parametaram uz algoritam razvijen od strane Hippo Medical. Lansiranje 2026. godine- pratite nas!',
    explore: 'Istraži',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'SINGAPUR (409051)',
    zipCode: 'Poštanski broj',
    emailCode: '409051',
    email: 'E-pošta',
    emailText: 'info@hippodiabetes.com',
    name: 'Ime*',
    company: 'Kompanija',
    message: 'Poruka',
    phone: 'Telefon',
    submit: 'Pošalji',
    commingSoon: 'Uskoro',
    cpInfo1:
      'Hippo Medical je globalna MedTech kompanija sa sedištem u Singapuru, posvećena unapređenju upravljanja hroničnim bolestima putem nosivih biosenzora medicinskog kvaliteta. Naša vizija je da omogućimo kontinuirano praćenje i naprednu analizu podataka.',
    cpInfo2:
      'Razvojem biosenzora nove generacije i napredne platforme za inteligentnu obradu podataka, cilj nam je da transformišemo dijagnostiku i predvodimo put ka proaktivnoj i personalizovanoj budućnosti.',
    submitFailed: 'Slanje nije uspelo', // ai翻译
    get invalidEmail() {
      return sr.home.invalidEmail;
    },
    fillAllFields: 'Molimo popunite ovo polje', // ai翻译
  },
  download: {
    language: 'Jezik',
    product: 'Proizvod',
    unit: 'Jedinica',
    fetchFailed: 'Dobavljanje nije uspelo', // ai翻译
  },
  help: {
    search: 'Pretraga',
    support: 'Podrška/Centar za pomoć/H1 CGM',
    source: 'HiPPO H1 CGM online izvori',
    viewAll: 'Pogledaj sve',
    insert: 'Kako postaviti H1 CGM',
    setUp: 'Kako podesiti H1 aplikaciju',
    faq: 'HiPPO H1 CGM FAQ',
    freq: 'Često postavljana pitanja',
    noData: 'Nema sadržaja..',
    searchKeys: {
      warmUp: 'Greška faze zagrevanja',
      waterLeakage: 'Curenje vode',
      lowGlucose: 'Nizak nivo glukoze',
      cannotPair: 'Uređaj se ne može povezati sa telefonom',
    },
  },
  faq: {
    faq: 'FAQ',
    general: 'Opšta pitanja',
    need: 'Treba vam pomoć?',
    here: 'Ovo su najčešća pitanja',
    technical: 'Tehnička pitanja',
  },
  lang: {
    chooseCountry: 'Izaberite zemlju/region',
    northAmerica: 'Severna Amerika', // ai翻译
    southAmerica: 'Južna Amerika', // ai翻译
    europe: 'Evropa', // ai翻译
    africa: 'Afrika', // ai翻译
    asia: 'Azija', // ai翻译
    oceania: 'Oceanija', // ai翻译
    other: 'Ostalo', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'Suzhou, Kina',
      subName: 'Proizvodna lokacija',
      hovData:
        'Globalni sedište za R&D/centar podataka/prodajma kancelarija pokriva Aziju i Australiju',
    },
    dubai: {
      name: 'Dubai',
      subName: 'Regionalna kancelarija',
      hovData: 'Prodajni tim JI Azije',
    },
    singapore: {
      name: 'Singapur',
      subName: 'Sedište',
      hovData: 'Prodajni tim JI Azije',
    },
    sanFrancisco: {
      name: 'San Francisko, SAD',
      subName: 'Regionalna kancelarija',
      hovData: 'Prodajni tim za  Severnu Ameriku',
    },
    barcelona: {
      name: 'Barselona',
      subName: 'Prodajna kancelarija',
      hovData:
        'Globalni sedište za R&D/centar podataka/prodajna kancelarija pokriva Aziju i Australiju',
    },
  },
};
export default sr;
